/****************************************************************************************************
 * デバイス情報
 ****************************************************************************************************/
var ua = navigator.userAgent.toLowerCase();
var isIE = /msie|trident/.test(ua);
var isIE10 = ua.indexOf("msie 10.0") > 0;
var isIE9 = ua.indexOf("msie 9.0") > 0;
var isEdge = ua.indexOf("edge/") > 0;
var isAndroid = ua.indexOf("android") > 0;
var isIPadOS = ua.indexOf("ipad") > -1 || (ua.indexOf("macintosh") > -1 && "ontouchend" in document);
var isIOS = /iphone|ipad|ipod|ios/.test(ua);
var isChrome = /chrome\/\d+/.test(ua) && !isEdge;
var isSP = isIOS || isAndroid;
var isPC = !isSP;
var checkWebGL = function () {
    var canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
};
var checkVersion = function () {
    // iOS
    if (isIOS) {
        ua.match(/os ([0-9_]+){1,3}/g);
        var versionInfo = RegExp.$1.split("_");
        // メジャーバージョン
        var version = Number(versionInfo[0]);
        // マイナーバージョン
        version += versionInfo[1] ? Number(versionInfo[1]) * 0.1 : 0;
        // マイクロバージョン
        return (version += versionInfo[2] ? Number(versionInfo[2]) * 0.01 : 0);
    }
    // Android
    if (isAndroid) {
        return parseFloat(ua.slice(ua.indexOf("android") + 8));
    }
    return -1;
};
var device = {
    isIE: isIE,
    isIE10: isIE10,
    isIE9: isIE9,
    isEdge: isEdge,
    isAndroid: isAndroid,
    isIPadOS: isIPadOS,
    isIOS: isIOS,
    isChrome: isChrome,
    isSP: isSP,
    isPC: isPC,
    isWebGL: checkWebGL(),
    pixelRatio: window.devicePixelRatio,
    version: checkVersion(),
};
export default device;
